export const ADD_ITEM = "ADD_ITEM";
export const GET_ITEMS = "GET_ITEMS";
export const DELETE_ITEM = "DELETE_ITEM";
export const ITEMS_LOADING = "ITEMS_LOADING";
export const ITEMS_ERROR = "ITEMS_ERROR";